/**
 * Product name shown to users (#1546): the placeholder "outcomes.lol" (was Outfox, #754). Always lower case, never
 * translated, never a link. The UI strings carry it in shared/i18n; this constant is for the header, which shows the
 * mascot mark plus the name as live text so the name can change without new artwork.
 */
export const PRODUCT_NAME = 'outcomes.lol';
